import * as React from "react";
import moment from "moment";
import _ from "lodash";

import Button from "../../../../core/Button";
import { QueryMenu } from "../QueryMenu";
import { Dropdown, Popover, Icon } from "antd";
import { Merchant } from "../../../../Merchant";
import { Publication } from "../../../../Analytics";
import "./style.scss";

const initialSelectedState: QuerySelector.SelectedState = {
  publicationIds: [],
  merchantId: null,
  startDate: null,
  endDate: null
};

module QuerySelector {
  export interface SelectedState {
    publicationIds: number[];
    merchantId: number;
    startDate: string;
    endDate: string;
  }

  export interface QuerySelectorState {
    menuVisible: boolean;
    selected: SelectedState;
  }

  export interface QuerySelectorProps {
    startDate: string;
    endDate: string;
    merchantId: number;
    merchants: Merchant[];
    publicationIds: number[];
    publications: Publication[];
    publications_loading?: boolean;
    selectedMerchant: Merchant;
    dateSelectionLimit?: number;
  }

  export interface QuerySelectorActions {
    getPublications: (merchantId: number, startDate: any, endDate: any) => void;
    removePublications: () => void;
    handleSubmit?: (
      publicationIds: number[],
      startDate: string,
      endDate: string,
      merchantId: number
    ) => void;
  }
}

export class QuerySelector extends React.Component<
  QuerySelector.QuerySelectorProps & QuerySelector.QuerySelectorActions,
  QuerySelector.QuerySelectorState
> {
  constructor() {
    super();
    this.state = {
      menuVisible: false,
      selected: initialSelectedState
    };
  }

  componentWillReceiveProps(nextProps: any, nextState: any) {
    if (!this.state.menuVisible) this.updateSelections(nextProps);

    let { startDate, endDate, merchantId, publicationIds } = this.props;
    let dateChanged =
      nextProps.start_date != startDate || nextProps.end_date != endDate;
    let merchantChanged = nextProps.merchant_id != merchantId;

    if (merchantChanged || dateChanged)
      if (nextProps.start_date && nextProps.end_date && nextProps.merchant_id)
        this.props.getPublications(
          nextProps.merchant_id,
          nextProps.start_date,
          nextProps.end_date
        );
  }

  updateSelections = (props: any) => {
    const publicationIds = props.publication_ids;
    if (
      publicationIds &&
      publicationIds.length > 0 &&
      this.state.selected.publicationIds.length == 0
    )
      this.setState(prevState => ({ selected: { ...prevState.selected, publicationIds } }));

    const merchantId = props.merchant_id;
    if (merchantId && !this.state.selected.merchantId)
      this.setState(prevState => ({ selected: { ...prevState.selected, merchantId } }));

    const startDate = props.start_date;
    if (startDate && !this.state.selected.startDate)
      this.setState(prevState => ({ selected: { ...prevState.selected, startDate } }));

    const endDate = props.end_date;
    if (endDate && !this.state.selected.endDate)
      this.setState(prevState => ({ selected: { ...prevState.selected, endDate } }));
  };

  setStateFromProps = (props: any) => {
    const { publicationIds, merchantId, startDate, endDate } = this.props;
    this.setState({
      selected: { publicationIds, merchantId, startDate, endDate }
    });
  };

  toggleMenu = (revertState = false) => {
    this.setState(prevState => ({ menuVisible: !prevState.menuVisible }));
    if (revertState) this.setStateFromProps(this.props);
  };

  togglePublication = (
    publication: Publication[],
    selected_publication_id: [number]
  ) => {
    let selectedPublicationIds: number[] = this.state.selected.publicationIds;
    selectedPublicationIds = selectedPublicationIds
      ? selectedPublicationIds
      : [];

    //Remove existing Ids
    if (selected_publication_id) {
      let publicationIds = publication.map((pub: any) => pub.flyer_run_id);
      selectedPublicationIds = _.difference(
        selectedPublicationIds,
        publicationIds,
        _.isEqual
      );
    } else {
      //Add net new Ids
      selectedPublicationIds = selectedPublicationIds.concat(
        publication.map((pub: any) => pub.flyer_run_id)
      );
    }

    this.setState(prevState => ({
      selected: {
        ...prevState.selected,
        publicationIds: selectedPublicationIds
      }
    }));
  };

  handleRangeSelect = (value: any[]) => {
    this.setState(prevState => ({
      selected: {
        ...prevState.selected,
        publicationIds: [],
        startDate: value[0].format("YYYY-MM-DD"),
        endDate: value[1].format("YYYY-MM-DD")
      }
    }));
  };

  handleMerchantSelect = (value: number /*, option: any*/) => {
    this.setState(prevState => ({
      selected: {
        ...prevState.selected,
        publicationIds: [],
        merchantId: value
      }
    }));
  };

  selectAllPublications = (select: boolean, publicationFilter: string) => {
    let { publications } = this.props;
    publications = _.filter(publications, function (o) {
      return o.flyer_run_name.toLowerCase().indexOf(publicationFilter) != -1;
    });
    const selectedPublications = select
      ? publications.map((i: any) => i.flyer_run_id)
      : [];
    this.setState(prevState => ({
      selected: { ...prevState.selected, publicationIds: selectedPublications }
    }));
  };

  render() {
    let {
      startDate,
      endDate,
      publicationIds = [],
      selectedMerchant
    } = this.props;
    return (
      <div className="query-selector query-selector-view-reports">
        <div style={{ paddingTop: 9 }}>
          <Dropdown
            overlay={
              <QueryMenu
                {...this.props}
                {...this.state.selected}
                togglePublication={this.togglePublication}
                toggleMenu={this.toggleMenu}
                selectAllPublications={this.selectAllPublications}
                handleMerchantSelect={this.handleMerchantSelect}
                handleRangeSelect={this.handleRangeSelect}
              />
            }
            visible={this.state.menuVisible}
          >
            <Button
              className="toggle-menu-btn"
              onClick={() => this.toggleMenu()}
            >
              <div style={{ paddingTop: 2, float: "left" }}>
                <div style={{ display: "inline-block", width: 175 }}>
                  <div style={{ fontWeight: "bold" }}>TIME PERIOD</div>
                  <div
                    id={"query-selector-date-range"}
                    style={{ display: "block", height: 10 }}
                  >
                    {startDate ? (
                      moment(startDate).format("ll") +
                      " - " +
                      moment(endDate).format("ll")
                    ) : (
                      <span style={{ color: "#bbb" }}>Select Time Period</span>
                    )}
                  </div>
                </div>

                <div style={{ display: "inline-block" }}>
                  <div style={{ fontWeight: "bold" }}>PUBLICATIONS</div>
                  <Popover
                    content={
                      <div>
                        {this.props.publications.map((i: any) => {
                          let publication_ids = this.props.publicationIds
                            ? this.props.publicationIds
                            : [];
                          if (publication_ids.includes(i.flyer_run_id))
                            return (
                              <div key={i.flyer_run_id}>
                                <span
                                  style={{
                                    marginRight: 20,
                                    display: "inline-block"
                                  }}
                                >
                                  {i.flyer_run_name}
                                </span>
                                <span
                                  style={{
                                    float: "right",
                                    display: "inline-block"
                                  }}
                                >{`${moment(i.available_from).format("MMM d")} - ${moment(i.available_to).format("d, YYYY")}`}</span>
                              </div>
                            );
                        })}
                      </div>
                    }
                    placement="bottom"
                    title="SELECTED PUBLICATIONS"
                  >
                    <Icon
                      type="info-circle"
                      style={{
                        float: "right",
                        marginRight: -35,
                        marginTop: 4,
                        display: "none"
                      }}
                    />
                  </Popover>
                  <div id={"query-selector-num-publications"}>
                    {publicationIds.length ? (
                      `${publicationIds.length} publication${publicationIds.length > 1 ? "s" : ""} selected`
                    ) : (
                      <span style={{ color: "#bbb" }}>Select Publications</span>
                    )}
                  </div>
                </div>
              </div>

              <Icon
                type="caret-down"
                style={{ float: "right", marginTop: 15, color: "#428CE8" }}
              />
              <div className="menu-divider" />
            </Button>
          </Dropdown>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/modules/common/components/QuerySelector/Selector/index.tsx